import useCashConfig from "hooks/useCashConfig";
import { PaymentButton } from "components/styles";
import { 
	Box, 
	Grid, 
	TextField, 
	Typography, 
	Collapse, 
	InputAdornment 
} from "@mui/material";

const TOCashPayment = ({
	loadingPay,
	handleCashSubmit,
	oId,
	showCashPayment
}) => {
	const {
		handleCashPaidChange,
		handleCashPayment,
		tipAmountValue,
		cashError,
		isRefundDueShow,
		cashPaid,
		CASH,
		payWithCreditCard,
		balanceDue,
		actionInProgress,
		handleBlur,
		setIsInputFocused,
		isInputFocused,
		ref
	} = useCashConfig(handleCashSubmit, oId);

	return (
		<>
			<Collapse in={payWithCreditCard === CASH} timeout="auto">
				{payWithCreditCard === CASH && (
					<Grid container spacing={1} sx={{ minHeight: '58px' }}>
            {showCashPayment && (
						   <>
               <Grid item xs={12}>
							<TextField
								margin="dense"
								id="cashAmount"
								label="Cash Payment"
								type="text"
								fullWidth
								variant="outlined"
								value={cashPaid}
								error={!!cashError}
								helperText={cashError}
								disabled={actionInProgress}
								onBlur={handleBlur}
								onFocus={() => setIsInputFocused(true)}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											$
										</InputAdornment>
									),
								}}
								inputProps={{
									min: 0.00,
									step: "any",
								}}
								onChange={handleCashPaidChange}
							/>
						</Grid>
            <Grid item xs={12}>
							<Box
								sx={{
									p: 2,
									bgcolor: '#f5f5f5',
									borderRadius: 1,
									minHeight: '80px'
								}}
							>
								<Typography variant="body2">
									Balance due: ${parseFloat(balanceDue).toFixed(2)}
								</Typography>
								<Typography variant="body2">
									Cash received: ${parseFloat(cashPaid || 0).toFixed(2)}
								</Typography>
								<Typography variant="body2" sx={{ fontWeight: 'bold' }}>
									Driver tip amount:  ${tipAmountValue ? parseFloat(tipAmountValue).toFixed(2) : '0.00'}
								</Typography>
							</Box>
						</Grid>
               </>
            )}  
						

						<Grid item xs={12} ref={ref} id="cash-payment-button">
							<PaymentButton
								onClick={handleCashPayment}
								loading={loadingPay}
								disabled={
									!!cashError || 
									!cashPaid || 
									isRefundDueShow || 
									actionInProgress || 
									isInputFocused ||
									loadingPay
								}
							>
								Pay
							</PaymentButton>
						</Grid>
					</Grid>
				)}
			</Collapse>
		</>
	);
};

export default TOCashPayment; 